import React from 'react';
import CircleQuestionMarkOutlined from '@uber/base-icons/circle-question-mark-outlined';
import { useStyletron } from 'baseui';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
type FrameFieldLabelProps = {
  label: string;
  tooltip: string;
};
export const FrameFieldLabel = ({
  label,
  tooltip
}: FrameFieldLabelProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale100,
    marginBottom: theme.sizing.scale300
  })}>
      <div className={css({
      ...theme.typography.LabelSmall,
      margin: 0
    })}>
        {label}
      </div>
      <StatefulTooltip content={tooltip} showArrow placement={PLACEMENT.top}>
        <CircleQuestionMarkOutlined size={14} />
      </StatefulTooltip>
    </div>;
};